<template>
  <el-dialog
    :class="{ 'alarm-confirm-dialog': true, 'fire-dialog': !dialogModal }"
    :visible.sync="alarmConfirmDialog"
    width="570px"
    :top="dialogTop"
    :modal="dialogModal"
    :style="fireStyle"
    :close-on-click-modal="false"
    :before-close="closeAlarmDialog"
    :show-close="true"
    v-loading="confirmLoading"
  >
    <template slot="title">
      <span class="alarm-confirm-title"
        ><title-icon />{{ $t("alarm.alarmConfirm") }}</span
      >
    </template>
    <!--确认告警弹窗-->
    <el-form :inline="true" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('base.position.project')">
            <template v-if="alarmConfirmInfo != null">
              <span>{{ form.projectName }}</span>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('alarm.time')">
            <template v-if="alarmConfirmInfo != null">
              <span>{{ form.timestamp }}</span>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('base.device.name')">
            <template v-if="alarmConfirmInfo != null">
              <el-tooltip
                :content="form.deviceName"
                placement="top"
              >
                <span class="deviceName">{{ form.deviceName }}</span>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('base.device.position')">
            <template v-if="alarmConfirmInfo != null">
              <el-tooltip :content="form.descName" placement="top">
                <span>{{ form.descName }}</span>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item :label="$t('commons.remark')">
          <template v-if="alarmConfirmInfo != null">
            <el-input
              type="textarea"
              style="width: 420px"
              :placeholder="$t('commons.pleaseInput')"
              v-model="form.alarmComment"
            ></el-input>
          </template>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button
        style="background-color: #5fbeaa; color: #fff"
        @click="confirmAlarm(1)"
        >{{ $t("alarm.faultConfirm") }}</el-button
      >
      <el-button
        style="background-color: #f0ad4e; color: #fff"
        @click="confirmAlarm(2)"
        >{{ $t("alarm.misreportConfirm") }}</el-button
      >
      <el-button
        style="background-color: #d43f3a; color: #fff"
        @click="confirmAlarm(3)"
        >{{ $t("alarm.fireConfirm") }}</el-button
      >
      <template v-if="isShowIsolate">
        <el-dropdown
          split-button
          type="success"
          style="margin-left: 10px"
          @click="handleCommand(60)"
          @command="handleCommand"
        >
          {{ $t("alarm.isolateShortcut") }}
          <el-dropdown-menu slot="dropdown" style="text-align: right">
            <el-dropdown-item command="30">{{
              $t("commons.min30")
            }}</el-dropdown-item>
            <el-dropdown-item command="120">{{
              $t("commons.min120")
            }}</el-dropdown-item>
            <el-dropdown-item command="180">{{
              $t("commons.min180")
            }}</el-dropdown-item>
            <el-dropdown-item command="360">{{
              $t("commons.min360")
            }}</el-dropdown-item>
            <el-dropdown-item command="720">{{
              $t("commons.min720")
            }}</el-dropdown-item>
            <el-dropdown-item command="1440">{{
              $t("commons.min1440")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import {
  confirmAlarm,
  isolateConfirm,
  batchConfirmAlarm
} from '@/api/business/base/tenant/historyalarm'

export default {
  name: 'ConfirmAlarm',
  props: {
    confirmAlarmEvent: {
      type: Function,
      default: null
    },
    //是否显示
    alarmConfirmDialog: {
      type: Boolean
    },
    // 告警信息
    alarmConfirmInfo: {
      type: Object,
    },
    // 是否显示隔离确认
    isShowIsolate: {
      type: Boolean,
      default: true
    },
    // 是否历史报警确认
    isHistoryConfirm: {
      type: Boolean,
      default: false
    },
    // top值
    dialogTop: {
      type: String,
      default: '15vh'
    },
    // 遮罩层显示
    dialogModal: {
      type: Boolean,
      default: true
    },
    // 火警弹框关闭
    fireClose: {
      type: Function,
      default: () => { }
    },
    // 火警弹框下标
    index: {
      type: Number,
      default: -1
    },
    // 火警样式
    fireStyle: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    currentSourceName: function () {
      this.initAlarmInfo();
    }
  },
  computed: {
    currentSourceName() {
      return this.alarmConfirmInfo;
    }
  },
  data() {
    return {
      form: {
        deviceId: null,
        sourceName: null,
        niagaraUuid: null,
        level: null,
        timestamp: null,
        deviceName: null,
        positionName: null,
        descName: null,
        projectName: null,
        alarmComment: null,
      },
      confirmLoading: false,
    }
  },
  created() {
    this.initAlarmInfo()
  },
  methods: {
    initAlarmInfo() {
      this.form = this.alarmConfirmInfo;
    },
    confirmAlarm(alarmLogic) {
      this.$confirm(this.$t('alarm.comfirmMsg'), this.$t('commons.warning'), {
        confirmButtonText: this.$t('commons.confirm'),
        cancelButtonText: this.$t('commons.cancel'),
        type: 'warning'
      }).then(() => {
        this.confirmLoading = true;
        let params = {
          niagaraUuid: this.alarmConfirmInfo.niagaraUuid,
          level: this.alarmConfirmInfo.level,
          sourceName: this.alarmConfirmInfo.sourceName,
          projectId: this.alarmConfirmInfo.projectId,
          alarmComment: this.alarmConfirmInfo.alarmComment,
          confirmFlag: alarmLogic
        }
        if (this.isHistoryConfirm) {
          //是历史报警确认（单个报警）
          confirmAlarm(params).then(() => {
            this.$emit('update:alarmConfirmDialog', false)
            this.fireClose(this.index)
            // 成功提示
            this.$message({
              message: this.$t('alarm.confirmSuccess'),
              type: 'success'
            });
            this.confirmAlarmEvent(this.form.sourceName, this.alarmConfirmInfo);
          }).finally(() => {
            this.confirmLoading = false;
          });
        } else {
          //非历史报警确认（批量点位报警）
          batchConfirmAlarm(params).then(() => {
            this.$emit('update:alarmConfirmDialog', false)
            this.fireClose(this.index)
            // 成功提示
            this.$message({
              message: this.$t('alarm.confirmSuccess'),
              type: 'success'
            });
            this.confirmAlarmEvent(this.form.sourceName, this.alarmConfirmInfo);
          }).finally(() => {
            this.confirmLoading = false;
          });
        }
      }).catch(error => {
        console.log(`未确认，原因 => ${error}`)
      });
    },
    closeAlarmDialog() {
      this.$emit('update:alarmConfirmDialog', false)
      this.fireClose(this.index)
    },
    handleCommand(command) {
      if (command) {
        this.doIsolate(Number(command));
      }
    },
    // 设备隔离
    doIsolate(isolateTime) {
      this.$confirm(this.$t('alarm.isolateMsg'), this.$t('commons.warning'), {
        confirmButtonText: this.$t('commons.confirm'),
        cancelButtonText: this.$t('commons.cancel'),
        type: 'warning'
      }).then(() => {
        let params = {
          deviceId: this.alarmConfirmInfo.deviceId,
          isolateTime: isolateTime,
          confirmFlag: 4,
          alarmComment: this.alarmConfirmInfo.alarmComment,
        }
        isolateConfirm(params).then(() => {
          this.$emit('update:alarmConfirmDialog', false)
          this.fireClose(this.index)
          // 成功提示
          this.$message({
            message: this.$t('alarm.confirmSuccess'),
            type: 'success'
          });
          this.confirmAlarmEvent(this.form.sourceName, this.alarmConfirmInfo);
        }).catch((error) => {
          console.log(`隔离失败，原因 => ${error}`)
        });
      }).catch(error => {
        console.log(`未隔离，原因 => ${error}`)
      });
    }
  }
}
</script>

<style scoped>
.alarm-confirm-dialog >>> .el-dialog__body {
  padding: 10px 0px;
  margin-left: 30px;
}

.alarm-confirm-title {
  font-size: 16px;
}
.fire-dialog {
  width: 670px;
  height: 370px;
}
.deviceName {
  display: inline-block;
  width: 170px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
